import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
  /* Altura fixa ao viewport: evita que a sidebar acompanhe a altura do conteúdo e empurre o logout */
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const SidebarBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  z-index: 9998;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease, visibility 0.2s ease;
`;

export const SidebarContainer = styled.aside`
  flex-shrink: 0;
  width: 80px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  border-right: 1px solid ${({ theme }) => theme.colors.gray[100]};
  box-shadow: 2px 0 5px rgba(0,0,0,0.05);

  ${({ $drawer, $open }) =>
    $drawer &&
    `
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    height: 100dvh;
    z-index: 9999;
    transform: translateX(${ $open ? '0' : '-100%' });
    transition: transform 0.25s ease;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.12);
  `}
`;

export const Menu = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  width: 100%;
  align-items: center;
  margin-top: 20px;
`;

export const MenuItem = styled.div`
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.gray[200]};
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: none;
  padding: 0;
  font: inherit;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary.light}20; /* 20% opacity */
    color: ${({ theme }) => theme.colors.primary.main};
  }

  ${({ theme, $disabled }) =>
    $disabled &&
    `
    cursor: not-allowed;
    opacity: 0.55;

    &:hover {
      background-color: ${theme.colors.gray[100]}66;
      color: ${theme.colors.gray[200]};
    }
  `}
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

/** Indicador “em breve” no canto superior direito do item da sidebar */
export const MenuItemCornerClock = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: ${({ theme }) => theme.colors.gray[200]};
  pointer-events: none;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const LogoutButton = styled(MenuItem)`
  margin-top: auto;
  color: ${({ theme }) => theme.colors.danger.main};
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.danger.light}20;
    color: ${({ theme }) => theme.colors.danger.dark};
  }
`;

export const MainContent = styled.main`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
`;

export const HeaderContainer = styled.header`
  min-height: 64px;
  flex-shrink: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px clamp(12px, 3vw, 24px);
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[100]};
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

export const MenuToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border: 1px solid ${({ theme }) => theme.colors.gray[100]};
  border-radius: 10px;
  background: #fff;
  color: ${({ theme }) => theme.colors.gray[900]};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.gray[100]};
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const TenantLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.gray[900]};

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  img {
    height: 32px;
    width: auto;
    max-width: min(240px, 45vw);
    flex-shrink: 0;
    object-fit: contain;
  }
`;

export const UserProfile = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex-shrink: 1;
  border: none;
  background: none;
  padding: 8px 0;
  cursor: pointer;

  span {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.gray[900]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover span {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: ${({ $compact }) => ($compact ? '0' : 'clamp(12px, 2.5vw, 24px)')};
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
`;
